<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("userAuditLog") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="Cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="userLog.date"
                  v-on:click="clearDate()"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="userLog.date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @input="onchangeStartDate()"
                ></Datepicker>
                <label :class="userLog.date ? 'active' : ''">{{
                  $t("shiftLogindate")
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedUser && selectedUser.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("user", 1) }}</label
              >
              <multiselect
                :options="users"
                v-model="selectUser"
                :searchable="true"
                label="username"
                track-by="user_id"
                placeholder="Select User"
                @select="onSelectUser($event)"
                @remove="removeUser"
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <b-dropdown id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <!-- Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end align-items-center mb-2"
        v-if="UserShiftsLogs.length"
      >
        <div>{{ $t("download") }} as:</div>
        <a
          target="_blank"
          title="Download as Excel"
          @click="onGetUserShiftLogs('excel')"
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("employeeid") }}</th>
              <!-- <th>{{ $t("loginTime") }}</th>
              <th>{{ $t("logouttime") }}</th> -->
              <th>{{ $t("Action") }}</th>
              <th>{{ $t("Description") }}</th>
              <th>{{ $t("Created") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(user, userIndex) in UserShiftsLogs"
            :key="userIndex"
            class="sph-report"
          >
            <tr>
              <td class="text-left">{{ user.name }}</td>
              <td class="text-left">{{ user.emp_code }}</td>
              <!-- <td>{{ user.login_date_time | fulldatemonparse }}</td>
              <td>{{ user.logout_date_time | fulldatemonparse }}</td> -->
              <td class="text-left">{{ user.ual_page_name }}</td>
              <td
                class="text-left"
                v-b-popover.hover.right="{
                  title: `<div class='fs-14'> Description</div>`,
                  customClass: `my-popover-class`,
                  content: getContent(user.ual_action),
                  html: true,
                }"
              >
                <div style="text-overflow: ellipsis">
                  {{
                    user.ual_action
                      ? user.ual_action.split(" / ").join(", ").length > 130
                        ? user.ual_action
                            .split(" / ")
                            .join(", ")
                            .substr(0, 100) + ".."
                        : user.ual_action.split(" / ").join(", ")
                      : "-"
                  }}
                </div>
              </td>
              <td>{{ user.created_at | fulldatemonparse }}</td>
            </tr>
          </tbody>
          <tbody v-if="UserShiftsLogs.length == 0">
            <tr>
              <td colspan="7">
                <!-- <h3  class="ml-3">{{ $t('noRecordsfound') }}</h3> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>

        <br />
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          @change="onChangePagination($event)"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";
import ReportsService from "@/services/NewReportService";

import moment from "moment";
import MasterService from "@/services/MasterService";

import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import xlsx from "json-as-xlsx";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      isRoleID: true,
      UserShiftsLogs: [],
      selectedUser: "",
      users: [],
      userLog: {
        date: null,
        cinema_id: null,
        user_id: null,
      },
      selectedCinema: "",
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      dropDown: {
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      perPage: 10,
      currentPage: 1,
      rows: 0,
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
      selectUser: null,
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
  },
  methods: {
    getContent(data) {
      let content = ``;
      if (data) {
        data.split(" / ").map((z) => {
          content += `<div>${z}</div>`;
        });
      }
      return content;
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.onGetUserShiftLogs();
      } else {
        this.currentPage = event;
        this.onGetUserShiftLogs();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSelectDetails: function (User) {
      this.$router.push({
        path: "/user-management/view-user-audit-log",
        query: {
          user_id: User.user_id,
          login_time: User.login_date_time,
          logout_time: User.logout_date_time,
          date: this.userLog.date,
        },
      });
    },

    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.userLog.cinema_id = x.cine_id;
                // this.selectedCinema = x.cine_name;
                // this.getUserList(x.cine_id);
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectUser: function (event) {
      this.selectUser = event;
      this.selectedUser = event.username || null;
      this.userLog.user_id = event.user_id || null;
      this.currentPage = 1;
      this.onGetUserShiftLogs();
    },
    removeUser() {
      this.selectUser = null;
      this.selectedUser = null;
      this.userLog.user_id = null;
      this.currentPage = 1;
      this.onGetUserShiftLogs();
    },
    onchangeStartDate: _.debounce(function (query) {
      this.currentPage = 1;
      this.onGetUserShiftLogs();
    }, 1.5 * 1000),
    onGetUserShiftLogs: function (type) {
      if (!type) {
        this.UserShiftsLogs = [];
      }
      if (this.userLog.cinema_id && this.userLog.date) {
        let payload = {
          cinema_id: this.userLog.cinema_id,
          login_date: moment(this.userLog.date).format("YYYY-MM-DD"),
          user_id: this.userLog.user_id ? this.userLog.user_id : null,
          type: type || "",
          limit: this.perPage,
          currentPage: this.currentPage,
        };

        if (type) {
          let qs = createQueryString(payload);
          window.open(`${this.BASE_URL}/api/reports/user-audit-logs${qs}`);
          return;
        }
        let loader = this.$loading.show();
        ReportsService.GetAuditLog(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();
            if (data.status && data.Records && data.Records.length > 0) {
              this.UserShiftsLogs = data.Records;
              if (this.currentPage == 1) {
                this.rows = data.paginationData.total;
              }
            } else if (data.Records && data.Records.length == 0) {
              this.rows = 0;
              this.$toasted.show("No Records Found.");
            } else {
              this.rows = 0;
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      } else {
        this.$toasted.show("Please select cinema and date");
      }
    },
    clearDate: function () {
      this.userLog.date = "";
    },
    onSelectCinema: function (event) {
      this.selectedCinema = event.cine_name;
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.userLog.cinema_id = event.cine_id;
      this.userLog.user_id = null;
      this.selectedUser = "";
      this.getUserList(event.cine_id);
      if (this.userLog.date) {
        this.onGetUserShiftLogs();
      } else {
        this.$toasted.show("Please select date");
      }
    },
    getUserList: function (cinema_Id) {
      let body = {
        limit: 100,
        currentPage: 1,
        orderby: null,
        columnName: null,
      };
      UserService.ListAllUser({}, body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.data.filter((x) => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied",
            });
          } else {
            this.$toasted.show(data.message);
          }
          console.log("this.users :", this.users);
        })
        .catch(this._CatchError);
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UserAuditLog/userAuditLog.vue